import get from "lodash/get"
import { observable, computed, action } from "mobx"
import { firebase, imagesFirebase } from "../../constants"
import { authStore, productStore } from "../../stores"
import { mapDesignToArea, getDefaultImagePlacement } from "./utils"
import {
  PRODUCT_SELECT_STEP,
  PRODUCT_DESIGN_STEP,
  PRODUCT_EDITOR_STEP,
} from "./constants"
import * as api from "../../api"

// temp
import mockProducts from "../../mock/products.json"
import mockups from "../../mock/mockups.json"

class AddProductStore {
  @observable step = PRODUCT_SELECT_STEP
  @observable error = null
  @observable saving = false
  @observable savingMessage = null
  @observable filesProgress = observable.map()
  // set by product selector
  @observable productId = null
  // set by product designer
  @observable productDesigns = {}
  @observable selectedColor = "White" // assuming all products have this color
  // set by product editor
  @observable productName = ""
  @observable sellerProfit = "5.00"

  // product from global products.json
  @computed
  get product() {
    return productStore.baseProducts.get(this.productId)
    // return mockProducts[this.productId]
  }

  get basePrice() {
    if (this.product) {
      // console.log(
      //   this.product.variants
      //     .map(v => v.price)
      //     .sort((a, b) => parseFloat(a) - parseFloat(b))
      // )
      return this.product.variants.reduce((base, v) => {
        const price = parseFloat(v.price)
        if (!base || price < base) {
          return price
        }
        return base
      }, null)
    }
  }

  // available files for selected product
  @computed
  get productFiles() {
    return get(this.product, "product.files").filter(f => f.id !== "back")
  }

  // mockups for selected product from global mockups.json
  @computed
  get productMockups() {
    return get(mockups.find(m => m.id === this.productId), "files")
  }

  // get list of colors from product variants
  @computed
  get variantColors() {
    if (this.product) {
      let seen = {}
      let colors = []
      this.product.variants.forEach(v => {
        if (!seen.hasOwnProperty(v.color)) {
          seen[v.color] = true
          colors.push({ color: v.color, color_code: v.color_code })
        }
      })
      return colors
    }
  }

  @action.bound
  reset() {
    this.step = PRODUCT_SELECT_STEP
    this.error = null
    this.saving = false
    this.filesProgress = observable.map()
    this.productId = null
    this.productDesigns = {}
    this.selectedColor = "White"
    this.productName = ""
    this.sellerProfit = "5.00"
  }

  @action.bound
  selectStep(step) {
    this.step = step
  }

  @action.bound
  selectProduct(id) {
    this.productId = id
    this.selectStep(PRODUCT_DESIGN_STEP)
  }

  @action.bound
  selectColor(color) {
    this.selectedColor = color
  }

  @action.bound
  selectImageForDesign(imageUrl, fileId) {
    const printarea = this.productMockups[fileId].printarea
    getDefaultImagePlacement(imageUrl, printarea).then(
      action(placement => {
        this.productDesigns = {
          ...this.productDesigns,
          [fileId]: {
            url: imageUrl,
            // convert to ratios
            top: placement.top / printarea.height,
            left: placement.left / printarea.width,
            width: placement.width / printarea.width,
            aspect: placement.aspect,
          },
        }
      })
    )
  }

  @action.bound
  changePlacementForDesign(placement, fileId) {
    this.productDesigns = {
      ...this.productDesigns,
      [fileId]: {
        ...this.productDesigns[fileId],
        top: placement.top,
        left: placement.left,
        width: placement.width,
        aspect: placement.aspect,
      },
    }
  }

  @action.bound
  changeName(str) {
    this.productName = str
  }

  @action.bound
  changeProfit(num) {
    this.sellerProfit = num
  }

  @action.bound
  submitDesign(files) {
    this.selectStep(PRODUCT_EDITOR_STEP)
  }

  @action.bound
  submitConfig() {
    const productKey = firebase
      .database()
      .ref(`stores/${authStore.userStoreId}/products`)
      .push().key

    this.processImageQueue(productKey)
    return this.saveProductConfig(productKey)
  }

  saveProductConfig(productKey) {
    const payload = {
      name: this.productName,
      userId: authStore.userId,
      color: this.selectedColor,
      profit: this.sellerProfit,
      product_id: this.productId,
      files: Object.keys(this.productDesigns).reduce((files, fileId) => {
        return { ...files, [fileId]: true }
      }, {}),
    }
    console.log("saveProductConfig", payload)
    return firebase
      .database()
      .ref(`stores/${authStore.userStoreId}/products/${productKey}`)
      .set(payload)
  }

  processImageQueue(productKey) {
    const dimensions = Object.values(this.product.product.dimensions).filter(
      (d, i, v) => v.indexOf(d) === i
    )
    const payload = {
      userId: authStore.userId,
      storeId: authStore.userStoreId,
      productId: productKey,
      images: Object.keys(this.productDesigns).reduce((images, fileId) => {
        const design = this.productDesigns[fileId]
        const dpi = 300
        return {
          ...images,
          [fileId]: {
            name: fileId,
            url: design.url,
            sizes: dimensions.map(dimension => {
              const [x, y] = dimension.split("x")
              const printarea = { width: x * dpi, height: y * dpi }
              return {
                name: dimension,
                width: printarea.width,
                height: printarea.height,
                overlay: mapDesignToArea(design, printarea),
              }
            }),
          },
        }
      }, {}),
    }
    this.createPrintFiles(payload)
  }

  createMockup = (queueItem, side, printFileBlob) => {
    var { storeId, productId } = queueItem
    var storageRef = imagesFirebase
      .ref()
      .child("mockups")
      .child(authStore.userId)
      .child(productId)
      .child(side + ".jpg")

    var mockupAsset = this.productMockups[side].assets[this.selectedColor]

    if (!mockupAsset) {
      debugger
    }

    //Do the background color, then the print file, then the overlay image
    var overlay = this.loadImage(mockupAsset.image, () => {
      var canvas = document.createElement("canvas")
      canvas.id = "Preview"
      canvas.width = Math.round(1000)
      canvas.height = Math.round(1000)
      const ctx = canvas.getContext("2d")

      if (mockupAsset.background_color) {
        //Draw the background color
        ctx.fillStyle = mockupAsset.background_color
        ctx.fillRect(0, 0, canvas.width, canvas.height)
        drawDesignAndBackground()
      } else if (mockupAsset.background_image) {
        //...or background image
        var bgImage = this.loadImage(mockupAsset.background_image, () => {
          ctx.drawImage(bgImage, 0, 0, canvas.width, canvas.height)
          drawDesignAndBackground()
        })
      } else {
        //...or white
        ctx.fillStyle = "#fff"
        ctx.fillRect(0, 0, canvas.width, canvas.height)
        drawDesignAndBackground()
      }

      function drawDesignAndBackground() {
        var blobImage = new Image()
        blobImage.onload = function() {
          ctx.drawImage(blobImage, 325, 190, 348, 466)
          ctx.drawImage(
            overlay,
            Math.round(0),
            Math.round(0),
            Math.round(1000),
            Math.round(1000)
          )

          canvas.toBlob(
            blob => {
              storageRef
                .put(blob, {
                  cacheControl: "public,max-age=3000",
                  contentType: "image/png",
                  name: productId + ".jpg",
                })
                .then(snapshot => {
                  console.log("uploaded mockup: ", snapshot)
                })
            },
            "image/jpeg",
            0.7
          )
        }
        blobImage.src = URL.createObjectURL(printFileBlob)
      }
    })
  }

  loadImage = (src, onload) => {
    var img = new Image()
    img.onload = onload
    img.setAttribute("crossOrigin", "anonymous")
    img.src = src
    return img
  }

  @action.bound
  setSaving(saving) {
    this.saving = saving
  }

  createPrintFiles(queueItem) {
    var { storeId, productId } = queueItem

    console.log("Processing store: " + storeId)
    console.log("product: " + productId)

    var pendingItems = 0
    const onComplete = () => {
      pendingItems--
      if (pendingItems == 0) {
        this.setSaving(false)
        console.log("Done generating print files.")
      }
    }

    this.setSaving(true)

    Object.keys(queueItem.images).forEach(imgKey => {
      var _this = this
      var img = queueItem.images[imgKey]
      var imageUri = img.url

      img.sizes.forEach(imgSize => {
        pendingItems += 1

        var storageFolderRef = imagesFirebase
          .ref()
          .child("print")
          .child(authStore.userId)
          .child(productId)
          .child(imgKey.toString())
        var storageRef = storageFolderRef.child(imgSize.name + ".png")

        var overlay = this.loadImage(imageUri, () => {
          var canvas = document.createElement("canvas")
          canvas.id = "Preview"
          canvas.width = Math.round(imgSize.width)
          canvas.height = Math.round(imgSize.height)
          const ctx = canvas.getContext("2d")

          ctx.drawImage(
            overlay,
            Math.round(imgSize.overlay.left),
            Math.round(imgSize.overlay.top),
            Math.round(imgSize.overlay.width),
            Math.round(imgSize.overlay.height)
          )

          canvas.toBlob(blob => {
            //TODO: get default size from either products.json or mockups.json
            if (imgSize.name == "12x16") {
              pendingItems += 1

              var storageSmallRef = storageFolderRef.child("small.png")

              var smallCanvas = document.createElement("canvas")
              smallCanvas.width = Math.round(400)
              smallCanvas.height = Math.round(
                imgSize.height * (400 / imgSize.width)
              )
              var smallContext = smallCanvas.getContext("2d")
              var blobImage = new Image()
              blobImage.onload = () => {
                smallContext.drawImage(
                  blobImage,
                  0,
                  0,
                  smallCanvas.width,
                  smallCanvas.height
                )
                smallCanvas.toBlob(smallBlob => {
                  _this.createMockup(queueItem, imgKey, smallBlob)

                  const uploadTask = storageSmallRef.put(smallBlob, {
                    cacheControl: "public,max-age=3000",
                    contentType: "image/png",
                    name: imgSize.name + "small.png",
                  })

                  const fileKey = imgSize.name + " thumbnail"
                  uploadTask.on(
                    "state_changed",
                    action(snap => {
                      // running
                      const progress =
                        snap.bytesTransferred / snap.totalBytes * 100
                      this.filesProgress.set(fileKey, progress)
                    }),
                    error => {
                      // error
                    },
                    action(() => {
                      //success
                      this.filesProgress.delete(fileKey)
                      onComplete()
                    })
                  )
                })
              }
              blobImage.src = URL.createObjectURL(blob)
            }

            const uploadTask = storageRef.put(blob, {
              cacheControl: "public,max-age=3000",
              contentType: "image/png",
              name: imgSize.name + ".png",
            })

            const fileKey = imgSize.name + " print file"
            uploadTask.on(
              "state_changed",
              action(snap => {
                // running
                const progress = snap.bytesTransferred / snap.totalBytes * 100
                this.filesProgress.set(fileKey, progress)
              }),
              error => {
                // error
              },
              action(() => {
                //success
                onComplete()
                this.filesProgress.delete(fileKey)
              })
            )
          })
        })
      })
    })
  }
}

export default new AddProductStore()



// WEBPACK FOOTER //
// ./src/products/add/store.js